
import { defineComponent } from "vue";
import BaseButton from "./base-button.vue";

export default defineComponent({
  components: { BaseButton },
  emits: ["cancel-clicked"],
});
